import {
  useGetNorfolkSouthernRequestsQuery,
  useSelectedRequestId,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import { FullWidthContent } from '../../tabs/OverviewTab/OverviewTab.styles';
import { FormContent } from '../ResourceRequestPanel/ResourceRequestPanel.styles';
import NorfolkSouthernForm from './NorfolkSouthernForm';
import NorfolkSouthernStatus from './NorfolkSouthernStatus';

/**
 * Detail view for the norfolk_southern panel view: the consist request form
 * when nothing is selected, otherwise the selected request's consist.
 */
function NorfolkSouthernView() {
  const selectedRequestId = useSelectedRequestId();
  const { data: requests } = useGetNorfolkSouthernRequestsQuery();

  const selectedRequest =
    requests?.find(request => String(request.id) === selectedRequestId) ?? null;

  let content = null;
  if (!selectedRequestId) {
    content = <NorfolkSouthernForm />;
  } else if (selectedRequest) {
    content = <NorfolkSouthernStatus request={selectedRequest} />;
  }

  return (
    <FormContent data-name="norfolk-southern-view">
      <FullWidthContent backgroundColor="background" noBorder>
        {content}
      </FullWidthContent>
    </FormContent>
  );
}

export default NorfolkSouthernView;
